import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import "./pageStyles.scss";
import {
  Button,
  ClickAwayListener,
  Popper,
  FormControl,
  Grid,
  InputAdornment,
  Menu,
  MenuItem,
  Modal,
  TextField,
  makeStyles,
  MenuList,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import CustomButton from "../components/common/controls/CustomButton";
import Search from "@material-ui/icons/Search";
import DMSelect from "../components/common/controls/DMSelect";
import DMGrid from "../components/common/controls/Grid/DMGrid";
import DMDeleteDialog from "../components/common/controls/DMDeleteDialog";
import * as miscAction from "../actions/miscAction";
import * as dataDescriptionAction from "../actions/dataDescriptionAction";
import * as _ from "lodash";
import DMModelSelect from "../components/common/DMModelSelect";
import DMModal from "../components/common/controls/DMModal";
import "../components/common/controls/Grid/gridControls.scss";
import Loading from "../components/Loading/Loading";
import {
  deleteDataConfig,
  sorrtDDValuesService,
  updateconfigGroupSortService,
} from "../services/DataDescsService";
import DeleteIcon from "@material-ui/icons/Delete";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import DragIndicatorIcon from "@material-ui/icons/DragIndicator";
import WarningPopup from "../components/common/controls/warningPopup";
import { constants } from "../constants/constants";
import { injectIntlTranslation } from "@carrier-ecat/workflowui-globalfunctions";
import { injectIntl } from "react-intl";
import ImportECATRules from "./ImportEcatRule";
import DownloadCSV from "./DownloadCsv";

var CONTROLS_DATA = require("./ControlsData.json");
var DATA_DESCRIPTIONS = CONTROLS_DATA.SCREENS.DATA_DESCRIPTIONS;

const DataDescriptions = ({
  dataDescriptionState,
  miscState,
  getDataDescriptions,
  getConfigGroups,
  createNewConfig,
  deleteDataDescription,
  createNewDataDescription,
  updateDataDescription,
  deleteDDValue,
  createNewDDValue,
  updateDDValue,
  setSnackBar,
  saveSortedConfigGroups,
  intl,
  fullLangCode,
}) => {
  const [gridData, setGridData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [showNewDD, setShowNewDD] = useState(false);
  const [newDD, setNewDD] = useState();
  const [showEdit, setShowEdit] = useState(false);
  const [showMoreOptions, setShowMoreOptions] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [selectedDD, setSelectedDD] = useState();
  const [newConfigGroup, setnewConfigGroup] = useState([]);
  const [configMenuList, setConfigMenuList] = useState([]);
  const [configGroup, setConfigGroup] = useState([]);
  const [newConfig, setNewConfig] = useState("");
  const [newConfigB, setNewConfigB] = useState([]);
  const [selectedConfig, setSelectedConfig] = useState("");
  const [open, setOpen] = useState(false);
  const [configValue, setConfigValue] = useState("");
  const [isDisabled, setIsDisabled] = useState(true);
  const [newConfigLoading, setNewConfigLoading] = useState(false);

  const [anchorEl1, setAnchorEl1] = React.useState(null);

  const [showImportRule, setShowImportRule] = useState(false);
  const onImportRuleClick = () => setShowImportRule(true);

  const dragRef = useRef();

  const handleClick = (event) => {
    setAnchorEl1(anchorEl1 ? null : event.currentTarget);
  };

  const openConfig = Boolean(anchorEl1);
  const popId = openConfig ? "simple-popper" : undefined;

  const handleClickAway = (event) => {
    setAnchorEl1(null);
  };

  const onNewDDClick = () => setShowNewDD(true);

  const handleClose = () => {
    setOpen(false);
    setAnchorEl1(null);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const getDDFields = (ddField) => {
    return [
      { name: "Job Name", value: ddField.jobName },
      { name: "Buyer Name", value: ddField.buyerName },
      { name: "Sales Engineer", value: ddField.saleEngineer },
      { name: "Model Number", value: ddField.modelNumber },
      { name: "Job Number", value: ddField.jobNumber },
      { name: "P.O. Number", value: ddField.poNumber },
      { name: "Prepared By", value: ddField.preparedBy },
      { name: "Electric Char", value: ddField.electricChar },
      { name: "Note 1", value: ddField.note1 },
      { name: "Note 2", value: ddField.note2 },
      { name: "Job Location", value: ddField.jobLocation },
      { name: "Other", value: ddField.other },
      { name: "Sales Office", value: ddField.salesOffice },
      { name: "Date", value: ddField.date },
      { name: "Revision", value: ddField.revision },
    ];
  };

  const handleChange = (value) => {
    setSortBy(value);
  };

  const handleNewDDName = (e) => {
    setNewDD({ ...newDD, ddName: e.target.value });
  };

  const handleNewDDDescription = (e) => {
    setNewDD({ ...newDD, ddDescription: e.target.value });
  };

  const handleConfigGroupNewDD = (item) => {
    setNewDD({ ...newDD, configGroup: item.configGroupId });
    setConfigValue(item.configGroupName);
    setSelectedConfig(item.configGroupName);
    setAnchorEl1(null);
  };

  const handleColumnTypeNewDD = (e) => {
    setNewDD({ ...newDD, columnType: e.target.value });
  };

  const [dataDescs, setDataDescs] = useState([]);

  const onDelete = (dd) => {
    setShowDelete(true);
    setSelectedDD(dd);
  };

  const handleSearch = _.debounce(function (val) {
    setSearchValue(val?.toLowerCase());
  }, 700);

  const handleCreateDD = async () => {
    const { isPresent } = isDDPresent(
      newDD.ddName,
      dataDescriptionState?.gridData?.data,
      newDD,
      "create"
    );
    if (isPresent) {
      setSnackBar(
        true,
        "error",
        injectIntlTranslation(
          intl,
          "DDAlreadyExistError",
          constants.DDAlreadyExistError
        )
      );
    } else {
      try {
        const payload = {
          modelId: miscState.selectedModel,
          ddName: newDD?.ddName,
          description: newDD?.ddDescription,
          sort: dataDescriptionState?.gridData?.data?.length + 1,
          configGroupId: newDD?.configGroup,
          columnType: newDD?.columnType,
        };

        let response = await createNewDataDescription(payload);
        if (!dataDescriptionState.createNewDD.hasError) {
          await getDataDescriptions(miscState.selectedModel);
          setDataDescs(dataDescriptionState.gridData.data);
          setSnackBar(
            true,
            "success",
            `${injectIntlTranslation(
              intl,
              "createNewDDSuccess",
              constants.createNewDDSuccess
            )} ${newDD?.ddName}`
          );
          closeModel();
        }
      } catch (error) {
        setShowNewDD(false);
        setSnackBar(
          true,
          "error",
          `${injectIntlTranslation(
            intl,
            "createDDError",
            constants.createDDError
          )} ${newDD?.ddName}`
        );
      }
    }
  };

  async function onCreateConfigGroups(model, dd, value) {
    try {
      const payload = {
        modelId: miscState.selectedModel,
        configGroupName: value,
        sort: dd,
      };
      await createNewConfig(payload);
      await onUpdateConfigGroups(model, dd, value);
      if (!dataDescriptionState?.createConfigGroups?.hasError) {
        await getDataDescriptions(miscState?.selectedModel);
        setDataDescs(dataDescriptionState.gridData.data);
      }
    } catch (error) {
      setSnackBar(
        true,
        "error",
        `${injectIntlTranslation(
          intl,
          "updateDDError",
          constants.updateDDError
        )} ${dd?.ddName}`
      );
    }
  }

  const isDdGroupPresent = (desData, data, ddValue) => {
    let isPresent = false;

    for (let dd of desData) {
      if (
        dd?.configGroup?.id === ddValue?.configGroupId &&
        data?.ddName?.toLowerCase() == dd?.ddName?.toLowerCase()
      ) {
        isPresent = true;
        break;
      }
    }

    return isPresent;
  };

  async function onUpdateConfigGroups(model, dd, value) {
    if (isDdGroupPresent(dataDescriptionState?.gridData?.data, dd, value)) {
      setSnackBar(
        true,
        "error",
        injectIntlTranslation(
          intl,
          "ddAlreadyExistError",
          constants.ddAlreadyExistError
        )
      );
      setDataDescs([...dataDescs]);
      return;
    }

    try {
      const payload = {
        modelId: model,
        ddNameId: dd?.ddId,
        ddName: dd?.ddName,
        description: dd?.description,
        sort: dd.sort,
        configGroupId: value?.configGroupId,
        columnType: dd?.columnType,
      };
      await updateDataDescription(payload);
      if (!dataDescriptionState?.updateDD?.hasError) {
        await getDataDescriptions(miscState?.selectedModel);
        setSnackBar(
          true,
          "success",
          `${injectIntlTranslation(
            intl,
            "configGroupUpdate",
            constants.configGroupUpdate
          )}`
        );
        setGridData([]);
      }
    } catch (error) {
      setSnackBar(
        true,
        "error",
        `${injectIntlTranslation(
          intl,
          "updateDDError",
          constants.updateDDError
        )} ${dd?.ddName}`
      );
    }
  }

  async function onUpdateColumnGroups(model, dd, value) {
    try {
      const payload = {
        modelId: model,
        ddNameId: dd?.ddId,
        ddName: dd?.ddName,
        description: dd?.description,
        sort: null,
        configGroupId: dd?.configGroup?.id,
        columnType: value?.label,
      };
      await updateDataDescription(payload);
      if (!dataDescriptionState.updateDD.hasError) {
        await getDataDescriptions(miscState?.selectedModel);
        // setDataDescs(dataDescriptionState.gridData.data);
        setSnackBar(
          true,
          "success",
          `${injectIntlTranslation(
            intl,
            "ddUpdateSuccess",
            constants.ddUpdateSuccess
          )}`
        );
      }
    } catch (error) {
      setSnackBar(
        true,
        "error",
        `${injectIntlTranslation(
          intl,
          "updateDDError",
          constants.updateDDError
        )} ${dd?.ddName}`
      );
    }
  }

  async function onCreateValue(model, dd, name, desc, sortNo = null) {
    try {
      const payload = {
        ddId: dd?.ddId,
        value: name,
        description: desc || name,
        sort: sortNo || dd?.ddValues?.length + 1,
        isActive: true,
      };
      await createNewDDValue(payload);
      if (!dataDescriptionState?.createConfigGroups?.hasError) {
        await getDataDescriptions(miscState?.selectedModel);
        setDataDescs(dataDescriptionState.gridData.data);
      }
    } catch (error) {
      setSnackBar(
        true,
        "error",
        `${injectIntlTranslation(
          intl,
          "updateDDError",
          constants.updateDDError
        )} ${dd?.ddName}`
      );
    }
  }

  async function onUpdateDDValue(model, dd, name, desc, ddValueId, sort) {
    try {
      const payload = {
        ddValueId: ddValueId,
        description: desc,
        sort: sort,
        isActive: true,
        ddId: dd?.ddId,
        value: name,
      };
      await updateDDValue(payload);
      if (!dataDescriptionState.updateDD.hasError) {
        setSnackBar(
          true,
          "success",
          injectIntlTranslation(
            intl,
            "ddUpdateSuccess",
            constants.ddUpdateSuccess
          )
        );
      }
    } catch (error) {
      setSnackBar(
        true,
        "error",
        `${injectIntlTranslation(
          intl,
          "updateDDError",
          constants.updateDDError
        )} ${dd?.ddName}`
      );
    }
  }

  async function onDeleteDDValue(model, dd, value) {
    try {
      const payload = {
        ddValueId: value,
      };
      await deleteDDValue(payload);
      if (!dataDescriptionState.updateDD.hasError) {
        await getDataDescriptions(miscState?.selectedModel);
        setDataDescs(dataDescriptionState.gridData.data);
      }
    } catch (error) {
      setSnackBar(
        true,
        "error",
        `${injectIntlTranslation(
          intl,
          "updateDDError",
          constants.updateDDError
        )} ${dd?.ddName}`
      );
    }
  }

  useEffect(() => {
    getDataDescriptions(miscState.selectedModel);
    // getConfigGroups(miscState.selectedModel);
  }, [miscState.selectedModel]);

  useEffect(() => {
    setIsDisabled(
      !(
        newDD &&
        newDD?.ddName?.length > 0 &&
        newDD?.ddDescription?.length > 0 &&
        newDD?.configGroup?.length > 0 &&
        newDD?.columnType?.length > 0
      )
    );
  }, [newDD]);

  useEffect(() => {
    const oldArray = JSON.parse(
      JSON.stringify(dataDescriptionState?.configGroups?.data)
    );
    const updatedArray = updatePropertyName(
      oldArray,
      "configGroupName",
      "label"
    );
    // setConfigMenuList(updatedArray);
    setnewConfigGroup(updatedArray);
  }, [dataDescriptionState?.configGroups?.data]);

  const updateConfigs = () => {
    const oldArray = JSON.parse(
      JSON.stringify(dataDescriptionState?.configGroups?.data)
    );
    const updatedArray = updatePropertyName(
      oldArray,
      "configGroupName",
      "label"
    );
    setnewConfigGroup(updatedArray);
  };

  useEffect(() => {
    setConfigGroup(dataDescriptionState?.configGroups?.data);
  }, [dataDescriptionState?.configGroups?.data, configGroup]);

  useEffect(() => {
    setLoading(dataDescriptionState.gridData.isLoading);
  }, [dataDescriptionState.gridData.isLoading]);

  useEffect(() => {
    if (
      !dataDescriptionState.gridData.isLoading &&
      dataDescriptionState?.gridData?.data?.length
    ) {
      setDataDescs(dataDescriptionState?.gridData?.data);
    }
  }, [
    dataDescriptionState?.gridData?.data,
    dataDescriptionState.gridData.isLoading,
  ]);

  useEffect(() => {
    if (dataDescriptionState.gridData.hasError) {
      setSnackBar(
        true,
        "error",
        injectIntlTranslation(intl, "retriveDDError", constants.retriveDDError)
      );
    }
  }, [dataDescriptionState.gridData.hasError]);

  const isDdDesPresent = (desData, data, ddValue) => {
    let isPresent = false;

    if (data?.description === ddValue) {
      return { isSame: true, isPresent };
    }

    for (let dd of desData) {
      if (
        dd?.description.toLowerCase() === ddValue.toLowerCase() &&
        data.ddName.toLowerCase() == dd.ddName.toLowerCase() &&
        dd?.configGroup?.id === data?.configGroup?.id
      ) {
        isPresent = true;
        break;
      }
    }

    return { isSame: false, isPresent };
  };

  const onUpdateDDdesc = async (model, dd, value) => {
    const { isSame, isPresent } = isDdDesPresent(
      dataDescriptionState?.gridData?.data,
      dd,
      value
    );

    if (isSame) {
      return;
    }

    if (isPresent) {
      setDataDescs([...dataDescs]);
      setSnackBar(
        true,
        "error",
        injectIntlTranslation(
          intl,
          "ddAlreadyExistError",
          constants.ddAlreadyExistError
        )
      );
      return;
    }

    try {
      const payload = {
        modelId: model,
        ddNameId: dd?.ddId,
        ddName: dd?.ddName,
        description: value,
        sort: dd?.sort,
        configGroupId: dd?.configGroup?.id,
        columnType: dd?.columnType,
      };
      await updateDataDescription(payload);
      if (!dataDescriptionState.updateDD.hasError) {
        // await getDataDescriptions(miscState?.selectedModel);
        setSnackBar(
          true,
          "success",
          injectIntlTranslation(
            intl,
            "ddUpdateSuccess",
            constants.ddUpdateSuccess
          )
        );
        // setGridData([]);
      }
    } catch (error) {
      setSnackBar(
        true,
        "error",
        `${injectIntlTranslation(
          intl,
          "updateDDError",
          constants.updateDDError
        )} ${dd?.ddName}`
      );
    }
  };

  const onSortUpdate = async (sortedData) => {
    let updatedFields = [];
    if (sortedData.length > 0) {
      updatedFields = sortedData.map((obj, index) => {
        return { ...obj, ["sort"]: index };
      });
      sorrtDDValuesService(updatedFields)
        .then((response) => {
          const data = response.status;
          setSnackBar(
            true,
            "success",
            injectIntlTranslation(
              intl,
              "sortDataSuccess",
              constants.sortDataSuccess
            )
          );
        })
        .catch((error) => {
          setSnackBar(
            true,
            "error",
            injectIntlTranslation(intl, "sortingError", constants.sortingError)
          );
        });
    }
  };

  const onUpdateDDName = async (model, dd, value) => {
    const { isSame, isPresent } = isDDPresent(
      value,
      dataDescriptionState?.gridData?.data,
      dd,
      "update"
    );
    if (isSame) {
      return;
    }
    if (isPresent) {
      setSnackBar(
        true,
        "error",
        injectIntlTranslation(
          intl,
          "ddAlreadyExistError",
          constants.ddAlreadyExistError
        )
      );
      setDataDescs([...dataDescs]);
    } else {
      try {
        const payload = {
          modelId: model,
          ddNameId: dd?.ddId,
          ddName: value,
          description: dd?.description,
          sort: dd?.sort,
          configGroupId: dd?.configGroup?.id,
          columnType: dd?.columnType,
        };
        await updateDataDescription(payload);
        if (!dataDescriptionState.updateDD.hasError) {
          setSnackBar(
            true,
            "success",
            injectIntlTranslation(
              intl,
              "ddUpdateSuccess",
              constants.ddUpdateSuccess
            )
          );
          // await getDataDescriptions(miscState?.selectedModel);
          // setGridData([]);
        }
      } catch (error) {
        setSnackBar(
          true,
          "error",
          `${injectIntlTranslation(
            intl,
            "updateDDError",
            constants.updateDDError
          )} ${dd?.ddName}`
        );
      }
    }
  };

  useEffect(() => {
    if (dataDescriptionState.gridData.isLoading || !dataDescs?.length) {
      return;
    }
    const ctrlData = [];
    const filteredDataDescs = dataDescs?.filter(
      (e) =>
        e.ddName.toLowerCase().includes(searchValue) ||
        e.description.toLowerCase().includes(searchValue)
    );

    _.sortBy(filteredDataDescs, sortBy).forEach((dd) => {
      console.log(dd);
      const filterData =
        dd.ddValues.slice().sort((a, b) => a.sort - b.sort) || [];
      ctrlData.push({
        rowId: uuidv4(),
        rowKey: dd?.ddId,
        sort: dd?.sort,
        rowValue: [
          {
            colType: "draggable-contained-label",
            colOptions: {
              value: dd?.ddName,
              tab: "DD-Name",
              width: "225px",
              model: miscState?.selectedModel,
              dd: dd,
              onUpdate: onUpdateDDName,
              fullLangCode: fullLangCode,
            },
          },
          {
            colType: "contained-label",
            colOptions: {
              value: dd?.description,
              width: "207px",
              tab: "DD-Desc",
              model: miscState?.selectedModel,
              dd: dd,
              onUpdate: onUpdateDDdesc,
              fullLangCode: fullLangCode,
            },
          },
          {
            colType: "grid-select",
            colOptions: {
              tab: "DD-ConfigType",
              dd: dd,
              model: miscState?.selectedModel,
              searchPlaceHolderText: "Search for a Config Group",
              selectInfoText: "Select a Config Group",
              selectedValue: dd?.configGroup?.name,
              menuList: _.sortBy(newConfigGroup, "sort"),
              width: "67px",
              textWidth: "150px",
              popperWidth: "324px",
              popperHeight: "500px",
              onUpdate: onUpdateConfigGroups,
              onCreate: onCreateConfigGroups,
              onChange: () => {
                // setShowAlert(true); setAlertSeverity('success'); setAlertMessage(`${model.ddName}-${model.regionName} has been updated.`)
              },
            },
          },
          {
            colType: "grid-select",
            colOptions: {
              tab: "DD-ColumnType",
              dd: dd,
              model: miscState?.selectedModel,
              searchPlaceHolderText: "Search for a Column Type",
              selectInfoText: "Select a Column Type",
              selectedValue:
                dd?.columnType === null ? "Dropdown" : dd?.columnType,
              menuList: DATA_DESCRIPTIONS.COLUMN_TYPE_LIST,
              width: "100px",
              textWidth: "120px",
              popperWidth: "250px",
              popperHeight: "270px",
              onUpdate: onUpdateColumnGroups,
              onChange: () => {
                // setShowAlert(true); setAlertSeverity('success'); setAlertMessage(`${model.ddName}-${model.regionName} has been updated.`)
              },
            },
          },
          {
            colType: "multiple-values",
            colOptions: {
              tab: "DD-Values",
              dd: dd,
              model: miscState?.selectedModel,
              searchPlaceHolderText: injectIntlTranslation(
                intl,
                "enterNewValuePlacholder",
                constants.enterNewValuePlacholder
              ),
              values: updatePropertyName(filterData, "value", "name"),
              onCreate: onCreateValue,
              onUpdate: onUpdateDDValue,
              onDelete: onDeleteDDValue,
              sortUpdate: onSortUpdate,
              fullLangCode: fullLangCode,
              disabled: dd?.columnType === "DISCRETE",
            },
          },

          {
            colType: "grid-actions",
            colOptions: [{ name: "delete", action: () => onDelete(dd) }],
          },
        ],
      });
    });

    let configInfo = _.uniqWith(
      configGroup,
      (obj1, obj2) => obj1.configGroupName === obj2.configGroupName
    );
    configInfo = _.sortBy(configInfo, "sort");
    let gridFilter = [];
    let filteredGrid = [];
    configInfo.length > 0 &&
      configInfo.forEach((config) => {
        filteredGrid = [];
        ctrlData.forEach((item) => {
          if (
            item.rowValue[2]?.colOptions?.selectedValue
              ?.trim()
              .toLowerCase() === config.configGroupName?.trim().toLowerCase()
          ) {
            filteredGrid.push(item);
          }
        });

        if (filteredGrid.length > 0) {
          gridFilter.push({
            configName: config.configGroupName,
            config,
            data: filteredGrid,
          });
        }
      });
    setGridData(gridFilter);
  }, [
    dataDescs,
    configGroup,
    searchValue,
    sortBy,
    dataDescriptionState.gridData.isLoading,
    fullLangCode,
  ]);

  const removeDuplicatesConfigs = (data) => {
    // return data.filter((obj,index,self)=> {
    //   return index === self.findIndex(o=> {
    //   return o.configGroupId === obj.configGroupId && o.configGroupName === obj.configGroupName
    //   })
    // })
    const seen = new Set();
    return data.filter((item) => {
      const sItem = JSON.stringify(item);
      if (!seen.has(sItem)) {
        seen.add(sItem);
        return true;
      }
      return false;
    });
  };

  function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
    };
  }

  const useStyles = makeStyles((theme) => ({
    paper: {
      position: "absolute",
      width: 400,
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2, 4, 3),
    },
    formControl: {
      minWidth: 222,
      "& .MuiSelect-root": {
        padding: "10px",
      },
    },
    formControlDropdown: {
      minWidth: 222,
      "& .MuiSelect-root": {
        padding: "18px",
        textAlign: "left",
      },
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    gridHeaderColumns: {
      display: "grid",
      width: "100%",
      gridTemplateColumns: "21% 21% 11% 11% 33% 3%",
    },
    noDataFound: {
      fontSize: "20px",
      display: "flex",
      justifyContent: "center",
      padding: "40px 0",
      cursor: "pointer",
      width: "100%",
    },
    saveButton: {
      minWidth: "150px",
      padding: "10px",
      backgroundColor: "#0e3b8d",
      color: "white",
      border: "none",
      borderRadius: "5px",
      fontSize: "16px",
      cursor: "pointer",
      transition: "background-color 0.3s",
      marginLeft: "auto",
    },
    cancelbutton: {
      width: "150px",
      padding: "10px",
      backgroundColor: "#fff",
      color: "#000",
      border: "1px solid #000",
      borderRadius: "5px",
      fontSize: "16px",
      cursor: "pointer",
      transition: "background-color 0.3s",
      marginLeft: "15px",
    },
  }));

  const classes = useStyles();
  // getModalStyle is not a pure function, we roll the style only on the first render
  const [modalStyle] = useState(getModalStyle);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMoreOptionsClose = (pageName) => {
    setAnchorEl(null);
    // history.push(`/${pageName}`)
  };

  const modelsList = [
    { label: "19MV-ASIA", value: 0 },
    { label: "30KAV-EMEA", value: 1 },
    { label: "30KAV-NA", value: 2 },
    { label: "19MV-EMEA", value: 3 },
    { label: "30KAV-ASIA", value: 4 },
  ];

  const [modelID, setModelID] = useState(modelsList[0].label);

  const handleModelId = (e) => {
    setModelID(e.target.value);
  };

  const updatePropertyName = (inputArray, oldPropertyName, newPropertyName) => {
    const updatedArray = inputArray.map((obj) => {
      const { [oldPropertyName]: propertyValue, ...rest } = obj;
      return {
        [newPropertyName]: propertyValue,
        enable: false,
        ...rest,
      };
    });
    return updatedArray;
  };

  const deleteConfirm = async (selectedDD) => {
    try {
      await deleteDataDescription({ ddNameId: selectedDD?.ddId });
      setShowDelete(false);
      const gridData = [...dataDescs];
      const filterRemove = gridData.filter((item) => {
        return !selectedDD.ddId.includes(item.ddId);
      });
      setDataDescs(filterRemove);
    } catch (error) {
      setSnackBar(
        true,
        "error",
        `${injectIntlTranslation(
          intl,
          "modelDeleteError",
          constants.modelDeleteError
        )} ${selectedDD.ddName}`
      );
    }
  };

  const handleNewConfigChange = (event) => {
    setNewConfig(event.target.value);
  };

  const uuidv4 = () => {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
    );
  };

  const isDDPresent = (ddName, data, ddValue, action) => {
    let isPresent = false;

    if (ddName === ddValue?.ddName && action === "update") {
      return { isSame: true, isPresent };
    }

    if (action === "update") {
      for (let dd of data) {
        if (
          ddName.toLowerCase() == dd.ddName.toLowerCase() &&
          dd?.configGroup?.id === ddValue?.configGroup?.id
        ) {
          isPresent = true;
          break;
        }
      }
    }

    if (action === "create") {
      for (let dd of data) {
        if (
          ddName.toLowerCase() == dd.ddName.toLowerCase() &&
          dd?.description.toLowerCase() ===
            ddValue?.ddDescription.toLowerCase() &&
          dd?.configGroup?.id === ddValue?.configGroup
        ) {
          isPresent = true;
          break;
        }
      }
    }

    return { isSame: false, isPresent };
  };

  const isConfigPresent = (configName, data) => {
    let isPresent = false;
    for (let dd of data) {
      if (configName.toLowerCase() == dd.configGroupName.toLowerCase()) {
        isPresent = true;
        break;
      }
    }
    return isPresent;
  };

  const handleCreateNewConfig = async (event) => {
    if (event.key === "Enter" && newConfig.trim() !== "") {
      if (
        isConfigPresent(newConfig, dataDescriptionState?.configGroups?.data)
      ) {
        setAnchorEl1(null);
        setSnackBar(
          true,
          "error",
          injectIntlTranslation(
            intl,
            "configAlreadyExistError",
            constants.configAlreadyExistError
          )
        );
      } else {
        try {
          setNewConfigLoading(true);
          const payload = {
            modelId: miscState.selectedModel,
            configGroupName: newConfig,
            sort: null,
          };
          await createNewConfig(payload, () => {
            getConfigGroups(miscState.selectedModel, () => {
              setNewConfigLoading(false);
            });
          });
          if (!dataDescriptionState?.configGroups?.hasError) {
            updateConfigs();
          }
          // setNewDD({ ...newDD, configGroup: newConfig });
          //  setConfigValue(newConfig);
          setNewConfig("");
        } catch (error) {
          setSnackBar(
            true,
            "error",
            `${injectIntlTranslation(
              intl,
              "drawingDeleteError",
              constants.drawingDeleteError
            )} ${selectedDD.drawingId}`
          );
        }
      }
    }
  };

  /* Model close click action*/
  const closeModel = () => {
    setNewDD({
      ...newDD,
      ddName: "",
      ddDescription: "",
      columnType: "",
      configGroup: "",
    });
    setShowNewDD(false);
    setIsDisabled(true);
    setAnchorEl1(null);
    setSelectedConfig("");
  };

  const generatePayload = (rowInfo, sortNumber) => ({
    modelId: miscState.selectedModel,
    ddNameId: rowInfo?.ddId,
    ddName: rowInfo?.ddName,
    description: rowInfo?.description,
    configGroupId: rowInfo?.configGroup?.id,
    columnType: rowInfo?.columnType,
    sort: sortNumber,
  });

  const onDrag = async (data) => {
    const filteredPayload = dataDescs.reduce((acc, des) => {
      const dataRowIndex = data.findIndex((row) => row?.rowKey === des?.ddId);
      if (dataRowIndex !== -1) {
        const dataRowSortValue = data[dataRowIndex]?.sort;
        const payload = generatePayload(des, dataRowSortValue);
        acc.push(payload);
      }
      return acc;
    }, []);

    const promises = filteredPayload.map((payload) =>
      updateDataDescription(payload)
    );

    try {
      await Promise.all(promises);
    } catch (e) {
      setSnackBar(
        true,
        "error",
        injectIntlTranslation(intl, "reorderError", constants.reorderError)
      );
    }

    return;
  };

  const deleteDataConfigCall = async (item) => {
    let payload = {
      modelId: miscState?.selectedModel,
      ConfigGroupId: item.configGroupId,
    };

    setNewConfigLoading(true);

    await deleteDataConfig(payload)
      .then((response) => {
        const { data } = response.data;
        getConfigGroups(miscState.selectedModel, () => {
          setNewConfigLoading(false);
        });
        setSnackBar(
          true,
          "success",
          `${item.configGroupName} ${injectIntlTranslation(
            intl,
            "ddDeleteSuccess",
            constants.ddDeleteSuccess
          )}`
        );
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  };

  const updateSortConfigGroup = async (payload) => {
    window.startLoading();
    await updateconfigGroupSortService(payload)
      .then((response) => {
        getConfigGroups(miscState.selectedModel, () => {
          window.stopLoading();
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleDrop = (droppedItem) => {
    if (!droppedItem.destination) return;
    const items = Array.from(gridData);
    const [reorderedItem] = items.splice(droppedItem.source.index, 1);
    items.splice(droppedItem.destination.index, 0, reorderedItem);

    let updatedConfig = items.map((ele, i) => ({ ...ele.config, sort: i + 1 }));

    saveSortedConfigGroups(updatedConfig);
    setConfigGroup([]);
    setNewConfigB(updatedConfig);
  };

  useEffect(() => {
    if (newConfigB.length) {
      setConfigGroup(newConfigB);
      updateSortConfigGroup(
        newConfigB.map((ele, index) => ({
          id: ele.configGroupId,
          sort: index + 1,
        }))
      );
    }
  }, [newConfigB]);

  const inputRef = useRef(null);

  useEffect(() => {
    if (openConfig) {
      const timer = setTimeout(() => {
        if (openConfig && inputRef.current) {
          inputRef.current.focus();
        }
      }, 100); // 100ms is usually safe for Popper
    }
  }, [openConfig]);

  return (
    <div container className="page-container content-center dd-wrapper">
      <Loading open={loading} />
      <ClickAwayListener onClickAway={handleClickAway}>
        <Grid container xs={12} md={12} className="page-content">
          <Grid container item xs={12} md={1}></Grid>
          <Grid container item xs={12} md={3} className="page-menu">
            <DMModelSelect />
          </Grid>
          <Grid
            container
            item
            xs={12}
            md={7}
            className="page-menu"
            justify="flex-end"
          >
            <Grid
              item
              container
              xs={12}
              md={2}
              justify="center"
              className="search-wrapper"
            >
              <TextField
                id="search"
                placeholder={injectIntlTranslation(
                  intl,
                  "searchPlacholder",
                  constants.searchPlacholder
                )}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  ),
                }}
                onChange={(e) => handleSearch(e.target.value)}
                autoComplete={"off"}
              />
            </Grid>
            <Grid
              item
              container
              xs={12}
              md={9}
              style={{ display: "flex", gap: "10px" }}
            >
              <div style={{ marginLeft: "auto", marginTop: "2px" }}>
                <DownloadCSV
                  label={injectIntlTranslation(
                    intl,
                    "exportData",
                    constants.exportData
                  )}
                  data={dataDescs || []}
                  fileName={"data-description-values.csv"}
                />
              </div>
              <div>
                <CustomButton
                  id="newDDName"
                  showGradient={true}
                  variant="contained"
                  color="primary"
                  disabled={false}
                  name={injectIntlTranslation(
                    intl,
                    "newDDName",
                    constants.newDDName
                  )}
                  onClick={onNewDDClick}
                />
              </div>

              <div style={{ width: "fit-content" }}>
                <CustomButton
                  id="importRule"
                  showGradient={true}
                  variant="contained"
                  color="primary"
                  disabled={false}
                  name={injectIntlTranslation(
                    intl,
                    "ecatRuleImportBtn",
                    constants.ecatRuleImportBtn
                  )}
                  onClick={onImportRuleClick}
                />
              </div>
            </Grid>
          </Grid>
          <Grid container item xs={12} style={{ padding: "0 100px" }}>
            {gridData.length > 0 ? (
              <div ref={dragRef} style={{ width: "100%" }}>
                <DragDropContext onDragEnd={handleDrop}>
                  <Droppable droppableId={`configGroupDrag`}>
                    {(provided) => (
                      <div
                        className="menu-list"
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                      >
                        {!!gridData?.length &&
                          gridData.map((item, index) => {
                            return (
                              <Draggable
                                id={item?.config.configGroupId}
                                key={item?.config.configGroupId}
                                draggableId={`${item?.config.configGroupId}`}
                                index={index}
                              >
                                {(provided2) => (
                                  <div
                                    ref={provided2.innerRef}
                                    {...provided2.draggableProps}
                                    {...provided2.dragHandleProps}
                                  >
                                    <div
                                      style={{
                                        marginBottom: "20px",
                                        border: "1px solid rgb(208 208 208)",
                                        background: "rgb(240 240 244)",
                                        borderRadius: "5px",
                                        padding: "0px 5px 5px 5px",
                                      }}
                                    >
                                      <DMGrid
                                        headers={DATA_DESCRIPTIONS.GRID_HEADERS}
                                        headerClassName="grid-header"
                                        data={item.data}
                                        loading={false}
                                        draggable={true}
                                        onDrag={onDrag}
                                        tableHead={
                                          <>
                                            <DragIndicatorIcon
                                              className="grid-action-item-multi"
                                              style={{
                                                cursor: "move",
                                                marginBottom: "-4px",
                                              }}
                                              fontSize="small"
                                            />
                                            <span>
                                              {injectIntlTranslation(
                                                intl,
                                                "configGroupTitle",
                                                constants.configGroupTitle
                                              )}
                                              :{" "}
                                            </span>
                                            <b>{` ${injectIntlTranslation(
                                              intl,
                                              item?.configName,
                                              item?.configName
                                            )}`}</b>
                                          </>
                                        }
                                        disablePagination={true}
                                      />
                                    </div>
                                  </div>
                                )}
                              </Draggable>
                            );
                          })}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </div>
            ) : (
              <Typography className={classes.noDataFound}>
                {loading
                  ? injectIntlTranslation(
                      intl,
                      "refreshData",
                      constants.refreshData
                    )
                  : injectIntlTranslation(
                      intl,
                      "dataNotFound",
                      constants.dataNotFound
                    )}
              </Typography>
            )}
          </Grid>

          <WarningPopup
            open={showNewDD}
            onClose={() => closeModel()}
            title={injectIntlTranslation(
              intl,
              "createNewDDTitle",
              constants.createNewDDTitle
            )}
            description={
              <form style={{ textAlign: "center" }} className="new-dd">
                <Grid container spacing={4}>
                  <Grid item xs={12}>
                    <TextField
                      id="outlined-basic"
                      label={injectIntlTranslation(
                        intl,
                        "DDNameLabel",
                        constants.DDNameLabel
                      )}
                      variant="outlined"
                      onChange={handleNewDDName}
                      style={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      id="outlined-basic"
                      label={injectIntlTranslation(
                        intl,
                        "DDDescriptionLabel",
                        constants.DDDescriptionLabel
                      )}
                      variant="outlined"
                      onChange={handleNewDDDescription}
                      style={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl
                      className={classes.formControlDropdown}
                      style={{ width: "100%" }}
                    >
                      <div
                        className="contained-grid-container"
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid rgba(63, 81, 181, 0.5)",
                          width: "100%",
                        }}
                      >
                        <>
                          <Button
                            color="primary"
                            onClick={handleClick}
                            style={{
                              textAlign: "left",
                              textTransform: "capitalize",
                              color: "#857d7d",
                              fontSize: "16px",
                              display: "block",
                            }}
                          >
                            {selectedConfig === "" && (
                              <span>
                                {" "}
                                {injectIntlTranslation(
                                  intl,
                                  "configGroupLabel",
                                  constants.configGroupLabel
                                )}
                              </span>
                            )}
                            {selectedConfig !== "" && (
                              <span>
                                {" "}
                                {injectIntlTranslation(
                                  intl,
                                  selectedConfig,
                                  selectedConfig
                                )}
                              </span>
                            )}
                          </Button>
                        </>
                        <Popper
                          id={popId}
                          open={openConfig}
                          anchorEl={anchorEl1}
                          placement="bottom"
                          className="config"
                          style={
                            newConfigLoading
                              ? { overflow: "hidden", pointerEvents: "none" }
                              : {}
                          }
                        >
                          {newConfigLoading && (
                            <div className="poper-loader">
                              <CircularProgress />
                            </div>
                          )}
                          <ClickAwayListener onClickAway={handleClickAway}>
                            <div
                              style={{
                                height: "324px",
                                width: "372px",
                                border: "1px none #fffff",
                                borderRadius: "4px",
                                backgroundColor: "#ffffff",
                              }}
                            >
                              <Grid xs={12} container>
                                <Grid
                                  item
                                  container
                                  style={{
                                    backgroundColor: "#D1E9FD",
                                    borderBottom: "1px solid #D1E9FD",
                                  }}
                                >
                                  <TextField
                                    inputRef={inputRef}
                                    placeholder={injectIntlTranslation(
                                      intl,
                                      "addNewConfigGroupPlaceholder",
                                      constants.addNewConfigGroupPlaceholder
                                    )}
                                    onChange={handleNewConfigChange}
                                    onKeyDown={handleCreateNewConfig}
                                    onBlur={(e) => e.preventDefault()}
                                    value={newConfig}
                                    style={{
                                      width: "100%",
                                      padding: "12px",
                                    }}
                                    disabled={newConfigLoading}
                                  />
                                </Grid>
                                {!newConfigLoading && (
                                  <Grid
                                    item
                                    container
                                    xs={12}
                                    spacing={0}
                                    style={{ paddingTop: "24px" }}
                                  >
                                    <MenuList
                                      style={{
                                        width: "100%",
                                        border: "1px none #fffff",
                                        borderRadius: "4px",
                                      }}
                                    >
                                      {(
                                        _.sortBy(configGroup, "sort") || []
                                      )?.map((item) => {
                                        return (
                                          <MenuItem
                                            value={item.configGroupId}
                                            style={{
                                              display: "flex",
                                              padding: "0px 15px",
                                            }}
                                          >
                                            <div
                                              style={{
                                                flex: "1",
                                                lineHeight: "32px",
                                              }}
                                              onClick={() =>
                                                handleConfigGroupNewDD(item)
                                              }
                                            >
                                              {injectIntlTranslation(
                                                intl,
                                                item.configGroupName,
                                                item.configGroupName
                                              )}
                                            </div>
                                            <div className="grid-action-item-icon-container">
                                              <DeleteIcon
                                                className="grid-action-item-icon"
                                                onClick={() =>
                                                  deleteDataConfigCall(item)
                                                }
                                              />
                                            </div>
                                          </MenuItem>
                                        );
                                      })}
                                    </MenuList>
                                  </Grid>
                                )}
                              </Grid>
                            </div>
                          </ClickAwayListener>
                        </Popper>
                      </div>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl
                      className={classes.formControlDropdown}
                      style={{ width: "100%" }}
                    >
                      <TextField
                        id=""
                        select
                        labelId="region-name-select-required-label"
                        label={injectIntlTranslation(
                          intl,
                          "columnTypeLabel",
                          constants.columnTypeLabel
                        )}
                        variant="outlined"
                        onChange={handleColumnTypeNewDD}
                        placeholder={injectIntlTranslation(
                          intl,
                          "columnTypeLabel",
                          constants.columnTypeLabel
                        )}
                        className="dropdown-btn-field"
                      >
                        {DATA_DESCRIPTIONS.COLUMN_TYPE_LIST.map(
                          (columnType) => {
                            return (
                              <MenuItem value={columnType.label}>
                                {injectIntlTranslation(
                                  intl,
                                  columnType.label,
                                  columnType.label
                                )}
                              </MenuItem>
                            );
                          }
                        )}
                      </TextField>
                    </FormControl>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    container
                    style={{ justifyContent: "center" }}
                  >
                    <Grid item xs={6}>
                      <Button
                        color="primary"
                        variant="contained"
                        onClick={handleCreateDD}
                        disabled={isDisabled}
                        className={classes.saveButton}
                      >
                        {injectIntlTranslation(
                          intl,
                          "createBtnLabel",
                          constants.createBtnLabel
                        )}
                      </Button>
                    </Grid>
                    <Grid item xs={6}>
                      <Button
                        variant="outlined"
                        onClick={() => closeModel()}
                        className={classes.cancelbutton}
                      >
                        {injectIntlTranslation(
                          intl,
                          "cancelBtnLabel",
                          constants.cancelBtnLabel
                        )}
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </form>
            }
            hideBtn={true}
          />

          <Modal open={showEdit} onClose={() => setShowEdit(false)}>
            <div style={modalStyle} className={classes.paper}>
              <h3 id="simple-modal-title">
                {selectedDD?.ddName} -{" "}
                {injectIntlTranslation(
                  intl,
                  "information",
                  constants.information
                )}
              </h3>
              <form style={{ textAlign: "center", scrollBehavior: "auto" }}>
                <Grid container spacing={1}>
                  {selectedDD &&
                    getDDFields(selectedDD).map((m) => {
                      return (
                        <Grid item xs={12}>
                          <TextField
                            size="small"
                            id="outlined-basic"
                            label={m.name}
                            variant="outlined"
                            value={m.value}
                          />
                        </Grid>
                      );
                    })}
                </Grid>
              </form>
            </div>
          </Modal>

          <ImportECATRules
            showImportRule={showImportRule}
            setShowImportRule={setShowImportRule}
            injectIntlTranslation={injectIntlTranslation}
            intl={intl}
            classes={classes}
            setLoading={setLoading}
            newConfigGroup={newConfigGroup}
            getDDValues={async () => {
              await getDataDescriptions(miscState?.selectedModel);
            }}
            getConfigGroups={getConfigGroups}
            setSnackBar={setSnackBar}
          />

          <WarningPopup
            open={showDelete}
            onClose={() => setShowDelete(false)}
            title={injectIntlTranslation(
              intl,
              "modelDeleteTitle",
              constants.modelDeleteTitle
            )}
            description={injectIntlTranslation(
              intl,
              "deleteDDWarningContent",
              constants.deleteDDWarningContent
            )}
            saveButtonLabel={injectIntlTranslation(
              intl,
              "deleteBtnLabel",
              constants.deleteBtnLabel
            )}
            onSave={() => {
              deleteConfirm(selectedDD);
            }}
          />

          <Menu
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={() => setShowMoreOptions(false)}
          >
            <MenuItem onClick={() => handleMoreOptionsClose("datadesc")}>
              {injectIntlTranslation(
                intl,
                "editDdNname",
                constants.editDdNname
              )}
            </MenuItem>
            <MenuItem onClick={() => handleMoreOptionsClose("views")}>
              {injectIntlTranslation(intl, "editviews", constants.editviews)}
            </MenuItem>
            <MenuItem onClick={() => handleMoreOptionsClose("drawings")}>
              {injectIntlTranslation(
                intl,
                "editDrawings",
                constants.editDrawings
              )}
            </MenuItem>
          </Menu>
        </Grid>
      </ClickAwayListener>
    </div>
  );
};

const mapStateToProps = (state) => ({
  dataDescriptionState: state.data_description,
  miscState: state.misc,
  fullLangCode: state.locale.message,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getDataDescriptions: async (requestPayload) =>
      dispatch(dataDescriptionAction.getDataDescriptions(requestPayload)),
    getConfigGroups: async (requestPayload, callback = () => {}) =>
      dispatch(dataDescriptionAction.getConfigGroups(requestPayload, callback)),
    createNewConfig: async (requestPayload, callback = undefined) =>
      dispatch(dataDescriptionAction.createNewConfig(requestPayload, callback)),
    deleteDataDescription: async (requestPayload) =>
      dispatch(dataDescriptionAction.deleteDataDescription(requestPayload)),
    createNewDataDescription: async (requestPayload) =>
      dispatch(dataDescriptionAction.createNewDataDescription(requestPayload)),
    updateDataDescription: async (requestPayload) =>
      dispatch(dataDescriptionAction.updateDataDescription(requestPayload)),
    deleteDDValue: async (requestPayload) =>
      dispatch(dataDescriptionAction.deleteDDValue(requestPayload)),
    createNewDDValue: async (requestPayload) =>
      dispatch(dataDescriptionAction.createNewDDValue(requestPayload)),
    updateDDValue: async (requestPayload) =>
      dispatch(dataDescriptionAction.updateDDValue(requestPayload)),
    setSnackBar: (show, severity, message) =>
      dispatch(miscAction.setSnackBar(show, severity, message)),
    saveSortedConfigGroups: (data) =>
      dispatch(dataDescriptionAction.saveSortedConfigGroups(data)),
  };
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(DataDescriptions)
);
